import { NavLink } from "react-router-dom";
import './header.css';
function Header (){

    return (
        <header className="header">  
            <div className="logo">
                <NavLink to="/" style={{ textDecoration: 'none' }}>
                    Kochetkov
                </NavLink>
            </div>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label className="menu-icon" htmlFor="menu-btn"><span className="navicon"></span></label>
            <ul className="menu">
            <li> 
            <NavLink to="/" >
                Home
                </NavLink>
                </li>
            <li> 
            <NavLink to="/skills" >
                Skills
                </NavLink>
                </li>
            <li>     
            <NavLink to="/projects"  >
                Projects
                </NavLink>
                </li>
            <li> 
            <NavLink to="/contacts" >
                Contacts
                </NavLink>
                </li>
            </ul>
        </header>
    );
}

export default Header;